// Discover meme images at build/dev time via Vite's import.meta.glob.
// Place image files in public/memes/.

const memeModules = import.meta.glob('/public/memes/*.{jpg,jpeg,png,gif,webp,svg}', {
  eager: true,
  import: 'default',
});

export function listMemes(): string[] {
  return Object.keys(memeModules).map((path) => {
    // /public/memes/cat.jpg -> /memes/cat.jpg
    return path.replace(/^\/public/, '');
  });
}
